import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { Marker, Popup, useMap } from "react-leaflet";
import { Check, Pencil } from "lucide-react";
import IconsensorImage from "../assets/images/positioning.png"
import api from '../api/api';
import L from 'leaflet';
import "./MarkerMap.css";

export default function Markerwhatever(props) {
  const [draggable, setDraggable] = useState(false)
  const [position, setPosition] = useState({lat:props.lat, lng:props.long})
  const markerRef = useRef(null)
  const [mapIsReady, setMapIsReady] = useState(false);

  const map = useMap();
  
  // Vérifier quand la carte est vraiment prête
  useEffect(() => {
    if (!map) return;
    
    const checkMapReady = () => {
      if (map._loaded && map._container && map._container.offsetWidth > 0) {
        setMapIsReady(true);
      } else {
        // Réessayer après un court délai
        setTimeout(checkMapReady, 50);
      }
    };
    
    map.whenReady(() => {
      setTimeout(checkMapReady, 50);
    });
    
    return () => {
      if (map && map.off) {
        map.off('ready');
      }
    };
  }, [map]);

  // Séparer la manipulation de la carte dans un useEffect séparé
  useEffect(() => {
    if (!mapIsReady || !map) return;
    
    try {
      let center = props.center;
      if (typeof center !== "undefined" && center.length > 0 && props.fromAction === true) {
        // Utiliser requestAnimationFrame pour s'assurer que le DOM est prêt
        window.requestAnimationFrame(() => {
          try {
            if (map && map._loaded) {
              map.setView(center, props.zoom || 14);
            }
          } catch (e) {
            console.error("Error setting view:", e);
          }
        });
      }
    } catch (error) {
      console.error("Error in map center effect:", error);
    }
  }, [map, mapIsReady, props.center, props.zoom, props.fromAction]);
  
  // Protéger les événements du marqueur
  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          setPosition(marker.getLatLng());
        }
      },
      click: (e) => {
        // Vérifier que la carte est prête avant de manipuler
        if (mapIsReady && map && map._loaded) {
          try {
            // Délai pour éviter les manipulations pendant les transitions
            setTimeout(() => {
              if (map && map._loaded) {
                map.flyTo(e.latlng, 9);
              }
            }, 10);
          } catch (error) {
            console.error("Error in flyTo:", error);
          }
        }
      }
    }),
    [map, mapIsReady],
  );
  
  const toggleDraggable = useCallback(() => {
    setDraggable((d) => !d)
  }, [])

  const savePosition = async() => {
    let Latitude = position.lat
    let Longitude = position.lng
    let idFarm = props.id
    try {
      await api.post('/farm/set-farm-position', { idFarm, Latitude, Longitude })
        .then(res => {
          console.log(res)
        }).catch((error)=>{
          console.log(error)
        })
      setDraggable(false)
    } catch (error) {
      console.error("Error saving position:", error);
    }
  }
  
  const Iconsensor = new L.Icon({
    iconUrl: IconsensorImage,
    iconSize: [48, 52],
    iconAnchor: [17, 45],
    popupAnchor: [3, -46]
  })
  
  return (
    <div>
      <Marker
        eventHandlers={eventHandlers}
        draggable={draggable}
        position={position}
        ref={markerRef}
        icon={Iconsensor}
      >
      <Popup>
      <div className="marker-popup-actions">
      {draggable ?
        <button type="button" onClick={savePosition} className="marker-popup-action-btn" aria-label="save position" title="save position">
          <Check aria-hidden="true" />
        </button>
        : <button type="button" onClick={toggleDraggable} className="marker-popup-action-btn" aria-label="edit position" title="edit position">
          <Pencil aria-hidden="true" />
        </button>
        }
      </div>

        <div>
        {props.name}
        </div>
      </Popup>
      
      </Marker>
    </div>
  );
}